<template>
	<div>
		<drawer :name="DRAWERS.MODULE_FORM">
			<module-form-drawer></module-form-drawer>
		</drawer>

		<router-view :key="`${ $route.params.slug }-${ $route.name }`"></router-view>
	</div>
</template>

<script>

import { DRAWERS } from '@/constants';
import ModuleFormDrawer from './drawers/ModuleFormDrawer';

export default {

	name: 'ModuleRootPage',

	props: ['slug', 'route'],

	data() {
		return {
			DRAWERS,
		};
	},

	components: {
		ModuleFormDrawer,
	},

};

</script>
